import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { TemplatesAllGetPayload } from 'Interfaces/Document';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload?: TemplatesAllGetPayload) =>
    $actions.document.getAllTemplates(dispatch, payload),
  );
};
